// extracted by mini-css-extract-plugin
module.exports = {"gradientLight3":"#f1f3f4","closeButton":"CloseButton__closeButton","closeButtonImg":"CloseButton__closeButtonImg"};